var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clearfix main_center" }, [
    _c("div", { staticClass: "top-content" }, [
      _c(
        "div",
        { staticClass: "left-navbar" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.backBtn } },
            [_vm._v("返回")]
          ),
          _vm.hasBtnPermission("btn_jz_pm-dgwitness-thirds-config_add")
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.routerEdit()
                    },
                  },
                },
                [_vm._v("编辑")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "right-content" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "form viewFormWrapper",
            attrs: { model: _vm.form, "label-width": "150px" },
          },
          [
            _c(
              "el-card",
              {
                staticClass: "box-card",
                staticStyle: { "margin-bottom": "0px" },
                style: { height: _vm.cardHight },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("第三方对接系统配置信息")])]
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "系统名称：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.systemName))]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "所属单位：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.orgName))]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "访问token：" } },
                          [_c("span", [_vm._v(_vm._s(_vm.form.token))])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "访问地址：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.accessUrl))]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "回调接口：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.callback))]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "接口密钥：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.secrets))]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "接口类型：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.interTypeName))]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "文件获取方式：" } },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.form.fileDownModName)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "所属交易中心：" } },
                          [_c("span", [_vm._v(_vm._s(_vm.form.tradeIdName))])]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }